module.exports = {"140171401":"唐槐园区街道","140171402":"学府园区街道","140171403":"阳曲产业园区街道","140171404":"潇河园区街道","140171405":"科创城街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140171.json
// module id = 268
// module chunks = 0